exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-add-override-day-button[data-v-c03d3654],\n.custom-add-override-day-button[data-v-c03d3654]:hover {\n  margin-left: 0;\n  background-color: #5f6771 !important;\n  margin-top: 10px;\n}\n.override-day-name-column[data-v-c03d3654] {\n  width: 300px;\n  min-width: 300px;\n  max-width: 300px;\n}\n.override-date-columns[data-v-c03d3654] {\n  width: 175px;\n  min-width: 175px;\n  max-width: 175px;\n}\n.override-day-table .md-table-row:nth-child(n + 3) > td[data-v-c03d3654] {\n  border-top: 0 !important;\n}\n.action-buttons-column button[data-v-c03d3654] {\n  margin-right: 5px;\n}\n", ""]);

// exports
